export interface RouteContext {
  container: HTMLElement;
}

export interface RouteDef {
  path: string;
  title: string;
  render: (ctx: RouteContext) => void;
}

const routes: RouteDef[] = [];

export function registerRoute(route: RouteDef): void {
  routes.push(route);
}

export function startRouter(container: HTMLElement, onRender: (route: RouteDef) => void): void {
  function render() {
    const hash = location.hash.replace(/^#/, '') || routes[0]?.path || '/';
    const route = routes.find((r) => r.path === hash) ?? routes[0];
    if (!route) return;

    container.innerHTML = '';
    route.render({ container });
    onRender(route);
  }

  window.addEventListener('hashchange', render);
  render();
}
